import { Controller } from "stimulus"

// Bugfix 21 (#1391): bij een vraag alleen de velden tonen die bij het gekozen
// soort antwoord horen (keuzes bij meerkeuze, de schaalgrootte bij een schaal).
export default class extends Controller {
  static targets = ["keuzes", "schaal"]

  connect() {
    this.wissel()
  }

  wissel() {
    const gekozen = this.element.querySelector("input[name='question[question_type]']:checked")?.value
    ;[...this.keuzesTargets, ...this.schaalTargets].forEach((blok) => {
      blok.hidden = !blok.dataset.voor.split(" ").includes(gekozen)
    })
  }
}
